import React, { useState } from 'react'
import BreadCrumbBar from '../../common/breadCrumbBar/BreadCrumbBar'
import '../../css/common.css'
import '../../css/notice.css'
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, CircularProgress} from '@mui/material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import { useEffect } from 'react';
import { ApiService } from '../../services/apiService';
import { useSelector } from 'react-redux';
import Warning from '../../common/alert/Warning';
import { dateFormat } from '../../common';
import Delete from '../../common/alert/Delete';

export default function NoticeList() {
	const navigate = useNavigate();
	const authData  = useSelector(state => state.auth);
	const [rowData, setRowData] = useState([]);
	const [rowCount, setRowCount] = useState(0);
	const [alertOpen, setAlertOpen] = useState(false);
	const [clickItem, setClickItem] = useState('');
	const [openWarning, setOpenWarning] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
	const [loading, setLoading] = useState(false);
	const role = authData.user.role.includes("admin");
	const [paginationModel, setPaginationModel] = useState({
		page: 0,
		pageSize: 30,
	});

	const columns = [
		{ 	field: 'no', 
			headerName: '번호', 
			minWidth: 70,
			flex: 1, 
		},
		{
			field: 'title',
			headerName: '제목',
			minWidth: 480,
			flex: 2,
			renderCell: (params) => {
				return (
					<p onClick={() => {navigate(`/notice/${params.row.id}`, {state: {
						id : params.row.id,
						title : params.row.title,
						body : params.row.body,
						admin_id : params.row.admin_id,
						created : params.row.created, 
					}})}} style={{cursor:"pointer"}}>{params.value}</p>
				)
			}
		},
		{
			field: 'admin_id',
			headerName: '작성자',
			minWidth: 320,
			flex: 2,
		},
		{
			field: 'created',
			headerName: '작성일자',
			minWidth: 180,
			flex: 2,
		},
		{
			field: 'delete',
			headerName: '삭제',
			minWidth: 110,
			flex: 2,
			renderCell: (params) => {
				// you will find row info in params
				return(
					<>
						<button className="deleteBtn" onClick={() => alertOpenHandle(params.row.id)}><RemoveCircleRoundedIcon sx={{pr:1, verticalAlign: "-1px", fontSize: "15px"}}/>삭제</button>
					</>
				)
			}
		},
	];

	const getNoticeList = async (limit, page) => {
		let params = `limit=${limit}&offset=${limit*page}`;
		
		try {
			setLoading(true);
			const noticeList = await ApiService.getBoardList(params);
			const rows = noticeList.data.datas.map((data, i) => {
				data.created = dateFormat(new Date(data.created))
				return ({ 'no': i + 1, ...data })
				// return data;
			})
			setRowData(rows);
			setRowCount(noticeList.data.total);
		} catch (error) {
			console.log('NoticeList - getNoticeList - error :: ', error);
		} finally {
			setLoading(false);
		}
	}

	useEffect(() => {
		getNoticeList(paginationModel.pageSize, paginationModel.page);
	}, [paginationModel.page])

	const writeClick = () => {
		return navigate('/notice/write');
	}

	const alertOpenHandle = (id) => {
		setAlertOpen(true);
		setClickItem(id);
	}

	const alertCloseHandle = () => {
		setAlertOpen(false);
		setClickItem('');
	}

	const handleDelete = async () => {
		try {
			await ApiService.deleteBoard(clickItem);
			alertCloseHandle();
		} catch(error) {
			console.log('NoticeList - handleDelete - error :: ', error)
			setOpenWarning(true);
			setErrorMsg(error.response.data.message);
		} finally {
			getNoticeList(paginationModel.pageSize, paginationModel.page);
		}
	}

	const closeWarning = (data) => {
		setOpenWarning(data);
	}

	return (
		<div className="containList">
			{ 
				(role !== true) ? (
					<Warning
						open={openWarning}
						onHideWarning={closeWarning}
						warningMsg={'해당 메뉴에 대한 권한이 없습니다!'}
					></Warning>
				) 
				: (
					<>
						<BreadCrumbBar menu="공지사항" smenu=""/>
						<div className="containItem">
							<div className="excelBtn">
								<Button variant="contained" startIcon={<AddCircleRoundedIcon />} onClick={writeClick}>등록</Button>
							</div>
						</div>
			
						<div className="gridItem">
							{ loading && (<CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%'}}/>) }
							<DataGrid
								sx={{
									'.MuiDataGrid-columnHeaderTitle': { 
										fontWeight: 'bold',								
									},
								}}
								rows={rowData}
								columns={columns}
								columnHeaderHeight={35}
								rowHeight={23}
								autoHeight={true}
								paginationMode="server"
								pageSizeOptions={[paginationModel.pageSize]}
								rowCount={rowCount}
								onPaginationModelChange={setPaginationModel}
								paginationModel={paginationModel}
								disableColumnMenu={true}
								disableSelectionOnClick
							/>	
						</div>

						<Warning
							open={openWarning}
							onHideWarning={closeWarning}
							warningMsg={errorMsg}
						></Warning>

						<Delete 
							openDelete={alertOpen}
							closeDelete={alertCloseHandle}
							onClickDelete={handleDelete}
						/>
					</>
				)
			}
		</div>
	)
}
